import React from 'react';
import { LuFileText, LuCalendar } from "react-icons/lu";

const InterfaceCard = ({ 
  title, 
  createdAt, 
  onClick, 
  isNew = false,
  icon = LuFileText,
  iconColor = "purple-400"
}) => {
  const Icon = icon;
  
  const formatDate = (date) => {
    if (!date) return 'Unknown';
    const dateObj = date.toDate ? date.toDate() : new Date(date);
    return dateObj.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  if (isNew) {
    return (
      <div className="w-full h-64 relative">
        <div 
          onClick={onClick} 
          className="p-4 hover:bg-[#2e2e2e] cursor-pointer transition w-full h-48 bg-[#1e1e1e] border border-dashed border-[#ffffff10] rounded-xl flex flex-col justify-between"
        >
          <div className="flex space-x-2 items-center h-fit">
            <div className={`p-3 h-fit w-fit bg-${iconColor}/20 rounded-lg`}>
              <Icon className={`text-${iconColor} w-6 h-6`} />
            </div>
            <div>
              <div className="text-lg font-medium text-white">{title}</div>
              <div className="text-sm text-[#ffffff50]">Interface</div>
            </div>
          </div>
          <div className="flex space-x-2 items-center h-fit">
            <div className="p-3 h-fit w-fit">
              <LuCalendar className="text-[#ffffff70] w-5 h-5" />
            </div>
            <div>
              <div className="flex-1 h-fit text-white opacity-50 text-sm font-normal">
                Created on
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-16 bg-[#1a1a1a] border-x border-b border-dashed border-[#ffffff10] rounded-b-xl flex items-center justify-center">
          <div className="text-xs text-[#ffffff30]">Click to create</div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-64 relative">
      <div
        onClick={onClick}
        className="p-4 hover:bg-[#2e2e2e] cursor-pointer transition w-full h-48 bg-[#1e1e1e] border border-[#ffffff10] rounded-xl flex flex-col justify-between"
      >
        <div className="flex space-x-2 items-center h-fit">
          <div className={`p-3 h-fit w-fit bg-${iconColor}/20 rounded-lg`}>
            <Icon className={`text-${iconColor} w-6 h-6`} />
          </div>
          <div>
            <div className="text-lg font-medium text-white">{title}</div>
            <div className="text-sm text-[#ffffff50]">Interface</div>
          </div>
        </div>
        <div className="flex space-x-2 items-center h-fit">
          <div className="p-3 h-fit w-fit">
            <LuCalendar className="text-[#ffffff70] w-5 h-5" />
          </div>
          <div>
            <div className="flex-1 h-fit text-white opacity-50 text-sm font-normal">
              Created on {formatDate(createdAt)}
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-clip w-full h-16 bg-[#1a1a1a] border-x border-b border-[#ffffff10] rounded-b-xl flex items-center space-x-2">
        <div className="w-4 h-full bg-gradient-to-r from-[#ffffff10] to-transparent" />
        <div className="flex-1 h-full flex items-center text-white opacity-50 text-sm font-medium px-2">
          <div className="flex items-center space-x-2">
            <div className={`h-2 w-2 rounded-full bg-${iconColor} animate-pulse`} />
            <span className="text-xs text-[#ffffff70]">Interface</span>
          </div>
        </div>
        <div className="w-4 h-full bg-gradient-to-l from-[#ffffff10] to-transparent" />
      </div>
    </div>
  );
};

export default InterfaceCard;